import type * as I from "core/api/coreApiClient";

export interface MessagesProps {
  messages?: I.Message[];
  denotation?: I.Denotation;
}

export function hasContentForMessages(messages: MessagesProps["messages"], denotation: MessagesProps["denotation"]) {
  return (messages && messages.length > 0) || denotation;
}
